module.exports = __webpack_public_path__ + "static/media/22444285_fashion_by_cowardrobertford_preview_1574777055660.885d9050.mp4";